<div class="yard-map-configuration">

  <div class="selection no-field-space">

    <div [formGroup]="mapSelectionForm">
      <mat-form-field class="map-selection">
        <mat-select
          placeholder="{{'choose map' | translate:['tmc-yard.widgets.yard-map-configuration.choose-map', translationService.language]}}"
          name="selectedMap" formControlName="selectedMap">
          <mat-option [value]="configuration.id" *ngFor="let configuration of configurations">
            {{configuration.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="spaced"></div>

    <button mat-stroked-button type="button" (click)="addMapConfiguration()">
      {{'add configuration' | translate:['tmc-yard.widgets.yard-map-configuration.action.add-configuration',
      translationService.language]}}
    </button>

    <div class="spaced grow"></div>

    <div [formGroup]="mapNameForm">
      <mat-form-field class="map-name">
        <input matInput name="name" formControlName="name"
          placeholder="{{'name' | translate:['tmc-yard.widgets.yard-map-configuration.name', translationService.language]}}"
          [required]="true" maxlength="255">
      </mat-form-field>
    </div>

    <div class="spaced"></div>

    <button mat-flat-button type="button" (click)="saveMapConfiguration()"
      [disabled]="configuration == null || !configuration.dirty || configuration.invalid">
      {{'save configuration' | translate:['tmc-yard.widgets.yard-map-configuration.action.save-configuration',
      translationService.language]}}
    </button>

    <div class="spaced"></div>

    <button mat-stroked-button type="button" (click)="deleteMapConfiguration()">
      {{'delete configuration' | translate:['tmc-yard.widgets.yard-map-configuration.action.delete-configuration',
      translationService.language]}}
    </button>

  </div>


  <div class="editor">
    <div class="col-wrapper">
      <div class="stations">
        <div class="stations-layout">
          <div class="stations-header">{{'stations' |
            translate:['tmc-yard.widgets.yard-map-configuration.stations.header',
            translationService.language]}}</div>
          <div class="stations-content-area">
            <div class="stations-entries-scrollable">
              <div class="station-container" *ngFor="let station of stations">
                <div class="station" draggable="true" (dragstart)="onDragStationStart($event, station)"
                  (dragend)="onDragStationEnd($event)">
                  {{station.name}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="center" *ngIf="configuration != null">
        <div class="center-content">
          <div #mapContainer id="map-container" class="map-container"
            [ngStyle]="{'width': configuration.width+'px', 'height': configuration.height+'px'}"
            (dragover)="onDragOverMap($event)" (drop)="onDropToMap($event)">

            <img [src]="configuration.mapURL" alt="map"
              [ngStyle]="{'width': configuration.width+'px', 'height': configuration.height+'px'}"
              *ngIf="configuration.mapResourceUUID != null && configuration.mapURL" />

            <ng-container *ngFor="let station of configuration.stationAssignments">
              <div *ngIf="!station.deleted" class="station" [ngClass]="{'waitingarea':station.isWaitingArea, 'selected': station.selected, 'extended': extendedStationTile}" draggable="true"
                (dragover)="onDragOverStation($event)" (click)="selectStationAssignment(station)"
                (drop)="onDropToStation($event, station)" (dragstart)="onDragStationAssignmentStart($event, station)"
                [ngStyle]="{'left': station.x+'px', 'top': station.y+'px', 'border-color':station.color}">

                <div class="station-inner">
                  <div class="station-identifier" [ngStyle]="{'color': station.fontColor }"
                    *ngIf="station.name && !station.identifier">
                    {{ station.name | uppercase }}
                  </div>
                  <div class="station-identifier" [ngStyle]="{'color': station.fontColor }" *ngIf="station.identifier">
                    {{ station.identifier | uppercase }}
                  </div>

                  <div *ngIf="station.isWaitingArea">
                    <div class="waitingarea-occupancy-numbers">
                      X / Y
                    </div>
                    <div class="waitingarea-occupancy">
                      <div class="waitingarea-occupancy-percentage"></div>
                    </div>
                  </div>

                </div>

              </div>
            </ng-container>
          </div>
        </div>
      </div>


      <div class="details">
        <div class="map-details">

          <div class="details-header">{{'map details' |
            translate:['tmc-yard.widgets.yard-map-configuration.map-details',
            translationService.language]}}</div>


          <app-map-details [configuration]="configuration"></app-map-details>

          <div class="details-header">{{'station details' |
            translate:['tmc-yard.widgets.yard-map-configuration.station-details',
            translationService.language]}}</div>

          <app-station-assignment-details (stationAssignmentRemoved)="onStationAssignmentRemoved($event)"
            [assignment]="configuration.selectedStationAssignment" [configuration]="configuration"
            *ngIf="configuration">
          </app-station-assignment-details>

          <div class="legend">
            <div class="details-header">{{'legend' | translate:['tmc-yard.widgets.yard-map-configuration.legend',
              translationService.language]}}</div>

            <div cdkDropList (cdkDropListDropped)="dropLegendListEntry($event)" class="legend-entries"
              *ngIf="configuration != null">

              <div cdkDrag *ngFor="let entry of configuration.legendEntries">

                <div class="legend-entry" *ngIf="entry.id !== configuration.editableLegendEntry?.id && !entry.deleted">
                  <div class="legend-entry-layout" (click)="editLegendEntry(entry)">
                    <i draggable="true" (dragstart)="onDragLegendEntryStart($event, entry)"
                      class="legend-entry-drag-arrow fa-light fa-arrow-left"></i>
                    <div class="colored-icon" [ngStyle]="{'background-color':entry.color}">
                      <i [ngStyle]="{'color': entry.fontColor }" class="fa-light fa-paragraph"></i>
                    </div>
                    <div class="name">{{entry.name}}
                    </div>
                    <div class="legend-entry-drag-handle">
                      <i cdkDragHandle class=" fa-light fa-bars"></i>
                    </div>
                  </div>
                </div>

                <div class="legend-entry-editor" [formGroup]="legendEntryForm"
                  *ngIf="entry.id === configuration.editableLegendEntry?.id  && !entry.deleted">
                  <div class="legend-entry-editor-layout">
                    <i draggable="true" (dragstart)="onDragLegendEntryStart($event, entry)"
                      class="legend-entry-drag-arrow fa-light fa-arrow-left"></i>

                    <div class="editor-fields">
                      <div class="editor-fields-layout">
                        <div class="row">
                          <div class="row-layout">
                            <mat-form-field class="input" class="grow">
                              <input autocomplete="off" matInput name="name" formControlName="name" placeholder="{{'name' | translate:['tmc-yard.widgets.yard-map-configuration.legend-name',
                            translationService.language]}}" [required]="true" maxlength="255">
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="row-layout">
                            <mat-form-field class="grow">
                              <app-color-picker formControlName="color" (colorSelected)="colorPickerChanged()"
                                placeholder="{{'fill color' | translate: ['tmc-yard.widgets.yard-map-configuration.color', translationService.language]}}"
                                name="color" [required]="false">
                              </app-color-picker>
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="row-layout">
                            <mat-form-field class="grow">
                              <app-color-picker formControlName="fontColor" (colorSelected)="colorPickerChanged()"
                                placeholder="{{'font color' | translate: ['tmc-yard.widgets.yard-map-configuration.font-color', translationService.language]}}"
                                name="fontColor" [required]="false">
                              </app-color-picker>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>

                    <i (click)="removeLegendentry(entry)" class="fa-light fa-trash"></i>
                    <div class="legend-entry-drag-handle">
                      <i cdkDragHandle class=" fa-light fa-bars"></i>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div class="legend-add-button" (click)="addLegendEntry()">
              <sc-icon iconClass="fa-plus"></sc-icon>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>
